import React, { useState } from 'react';
import classes from './liveViewSearchBar.module.css';
import filters from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/filters2.png';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Divider } from 'primereact/divider';
import ExportExcel from '../../components/ExcelExport/ExcelExport';

const LiveViewSitesSearchBar = ({
  placeholder,
  value,
  onChange,
  groups,
  groupName,
  setGroupName,
  excelData,
  fileName,
}) => {

  const [showFilters, setShowFilters] = useState(false);
  const [localGroupName, setLocalGroupName] = useState(groupName);

  const handleClear = () => onChange({ target: { value: '' } });

  const handleApply = () => {
    setGroupName(localGroupName);
    setShowFilters(false);
  };

  const handleReset = () => {
    setLocalGroupName(null);
    setGroupName(null);
    setShowFilters(false);
  };

  const hasActiveFilters = !!groupName;

  return (
    <div className={classes.wrapper}>
      <div className={classes.searchContainer}>
        <input
          className={classes.searchBar}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          spellCheck={false}
        />
        <div className={classes.buttonGroup}>
          {value && (
            <button className={classes.clearButton} onClick={handleClear} type="button">
              ×
            </button>
          )}
          <button className={classes.filterButton} onClick={() => setShowFilters(p => !p)} type="button">
            <img style={{ height: '30px', width: '30px', opacity: hasActiveFilters ? 1 : 0.5 }} src={filters} />
          </button>
        </div>

        {showFilters && (
          <div className={classes.filterDropdown}>
            <div className={classes.filterRow}>
              <label className={classes.filterLabel}>Group:</label>
              <Dropdown
                value={localGroupName}
                className="w-full md:w-14rem"
                style={{ width: '280px' }}
                onChange={(e) => setLocalGroupName(e.value)}
                options={groups}
                optionLabel="name"
                optionValue="name"
                placeholder="All groups"
                showClear
                filter
                filterPlaceholder="Search groups..."
              />
            </div>
            <Divider type="solid" />
            <div className={classes.buttonRow}>
              <Button icon="pi pi-refresh" type="button" label="Reset" onClick={handleReset} outlined severity="danger" />
              <Button icon="pi pi-check" type="button" label="Apply" onClick={handleApply} />
            </div>
          </div>
        )}
      </div>

      <ExportExcel
        excelData={excelData}
        fileName={fileName}
        title={fileName}
        colWidths={[{ wch: 30 }, { wch: 30 }, { wch: 30 }]}
      />
    </div>
  );
};

export default LiveViewSitesSearchBar;
